import React from 'react';
import { CheckCircle } from '@mui/icons-material';
import styles from '../../../styles/automation/index.module.scss';

export const getOptionLabel = (option) => {
    if (!option) return '';

    if (option.isLoadingPlaceholder) return 'Loading...';

    if (typeof option === 'string') return option;

    const key = option.key || option.id || 'Unknown';
    const title = option.title || option.name || 'Untitled';

    return `${key} - ${title}`;
};

export const getOptionValue = (option) => {
    if (!option) return null;
    if (option.isLoadingPlaceholder) return option.id || null;
    if (typeof option === 'string') return option;
    return option.id || option.key || null;
};

/**
 * Ensures the URL/selected test case appears in dropdown options even when
 * it is absent from the filtered list (e.g. onlyInstructionAvailable).
 * Prepends when missing; skips when already present.
 */
export const mergeUrlTestCaseIntoOptions = (options, urlTestCase) => {
    if (!urlTestCase?.id) return options;
    const urlTestCaseId = getOptionValue(urlTestCase);
    const alreadyPresent = options.some(
        (opt) => String(getOptionValue(opt)) === String(urlTestCaseId)
    );
    if (alreadyPresent) return options;
    return [urlTestCase, ...options];
};

export const filterOptions = (options) => {
    return options;
};

export const isOptionEqualToValue = (option, value) => {
    const getValue = (opt) => {
        if (opt?.isLoadingPlaceholder) return opt.id;
        return opt?.id || opt;
    };
    return getValue(option) === getValue(value);
};

export const renderOption = (option, { selected }, getOptionLabelFn) => {
    if (option.isLoadingPlaceholder) {
        return (
            <div className={styles.loadingOption} style={{ pointerEvents: 'none' }}>
                <div className={styles.loadingSpinner}></div>
                <span>Loading more test cases...</span>
            </div>
        );
    }

    return (
        <div className={styles.customOption}>
            <div className={styles.optionHeader}>
                <span className={styles.optionTitle}>
                    {getOptionLabelFn(option)}
                </span>
                {selected && (
                    <CheckCircle className={styles.selectedIcon} fontSize="small" />
                )}
            </div>
            {option.module && (
                <span className={styles.optionModule}>
                    Module: {option.module.name}
                </span>
            )}
        </div>
    );
};

export const getNoOptionsText = (loading, testCaseOptionsLength, apiError) => {
    if (loading && testCaseOptionsLength > 0) {
        return 'Loading more options...';
    }
    if (loading && testCaseOptionsLength === 0) {
        return 'Searching test cases...';
    }
    return apiError ? `Error: ${apiError}` : 'No options found';
};
